import { render } from "./BaseChatView.vue?vue&type=template&id=96d3f2f6&scoped=true"
import script from "./BaseChatView.vue?vue&type=script&lang=js"
export * from "./BaseChatView.vue?vue&type=script&lang=js"

import "./BaseChatView.vue?vue&type=style&index=0&id=96d3f2f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d3f2f6"]])

export default __exports__